import { render, staticRenderFns } from "./ControlsContainer.vue?vue&type=template&id=639a4354&scoped=true&"
import script from "./ControlsContainer.vue?vue&type=script&lang=js&"
export * from "./ControlsContainer.vue?vue&type=script&lang=js&"
import style0 from "./ControlsContainer.vue?vue&type=style&index=0&id=639a4354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639a4354",
  null
  
)

export default component.exports